import { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import useTema from '../../hooks/useTema';
import Pauta from './Pauta';
import { Barra, diaLongo, primeiroNome } from './comum';

export default function Equipe() {
  const t = useTema();
  const [dados, setDados] = useState(null);
  const [selecionado, setSelecionado] = useState(null);

  const carregar = useCallback(() => {
    api.get('/pauta/equipe').then((r) => setDados(r.data)).catch(() => {});
  }, []);
  useEffect(() => {
    carregar();
    const id = setInterval(carregar, 60000);
    return () => clearInterval(id);
  }, [carregar]);

  if (!dados) return <p style={{ color: t.textMuted, padding: 20 }}>Carregando a equipe…</p>;

  // Quem tem pauta (rotinas ou demandas) aparece; o admin só se tiver algo
  const pessoas = dados.equipe.filter((p) => p.nivel_acesso > 1 || p.hoje_total || p.atrasadas || p.mes_feitas);
  const totalHoje = pessoas.reduce((s, p) => s + p.hoje_total, 0);
  const feitasHoje = pessoas.reduce((s, p) => s + p.hoje_feitas, 0);
  const totalAtrasadas = pessoas.reduce((s, p) => s + p.atrasadas, 0);

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap', marginBottom: 18 }}>
        <div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: t.textTitle }}>Equipe</h1>
          <p style={{ fontSize: 13, color: t.textMuted }}>{diaLongo(dados.hoje)} · clique numa pessoa para ver a pauta dela</p>
        </div>
        <div style={{ display: 'flex', gap: 18, fontSize: 13, color: t.textSecond }}>
          <span>Hoje: <strong style={{ color: t.text }}>{feitasHoje}/{totalHoje}</strong> feitas</span>
          <span style={{ color: totalAtrasadas ? '#EF4444' : t.textSecond }}>
            Atrasadas: <strong>{totalAtrasadas}</strong>
          </span>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 12 }}>
        {pessoas.map((p) => {
          const ativo = selecionado?.id === p.id;
          const pctPrazo = p.mes_feitas ? Math.round((p.mes_no_prazo / p.mes_feitas) * 100) : null;
          return (
            <button key={p.id} onClick={() => setSelecionado(ativo ? null : p)}
              style={{
                textAlign: 'left', cursor: 'pointer', background: t.bgCard, borderRadius: 16, padding: '16px 16px 14px',
                border: `1.5px solid ${ativo ? '#6C4CF5' : p.atrasadas ? 'rgba(239,68,68,.45)' : t.border}`,
              }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{
                  width: 38, height: 38, borderRadius: '50%', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  background: 'linear-gradient(135deg, #8b5cf6, #6d28d9)', color: '#fff', fontWeight: 700,
                }}>{p.nome.charAt(0)}</div>
                <div style={{ minWidth: 0 }}>
                  <p style={{ fontSize: 15, fontWeight: 700, color: t.text }}>{primeiroNome(p.nome)}</p>
                  <p style={{ fontSize: 12, color: t.textMuted }}>{p.cargo || '—'}</p>
                </div>
                {p.atrasadas > 0 && (
                  <span style={{ marginLeft: 'auto', fontSize: 11, fontWeight: 700, color: '#EF4444', background: 'rgba(239,68,68,.12)', padding: '2px 8px', borderRadius: 999 }}>
                    {p.atrasadas} atrasada{p.atrasadas > 1 ? 's' : ''}
                  </span>
                )}
              </div>
              <div style={{ marginTop: 14 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 12, color: t.textSecond, marginBottom: 5 }}>
                  <span>Hoje</span><span>{p.hoje_feitas}/{p.hoje_total}</span>
                </div>
                <Barra feitas={p.hoje_feitas} total={p.hoje_total} altura={7} t={t} />
              </div>
              {p.em_andamento > 0 && (
                <p style={{ fontSize: 12, color: t.textSecond, marginTop: 8 }}>{p.em_andamento} em andamento (prazo mais à frente)</p>
              )}
              <p style={{ fontSize: 12, color: t.textMuted, marginTop: 10 }}>
                No mês: {p.mes_feitas} feita{p.mes_feitas === 1 ? '' : 's'}
                {pctPrazo !== null && <> · <span style={{ color: pctPrazo >= 90 ? '#22C55E' : pctPrazo >= 70 ? '#F59E0B' : '#EF4444' }}>{pctPrazo}% no prazo</span></>}
              </p>
            </button>
          );
        })}
      </div>

      {selecionado && (
        <div style={{ marginTop: 24 }}>
          <Pauta usuarioId={selecionado.id} embutida key={selecionado.id} />
        </div>
      )}
    </div>
  );
}
